import {useCallback} from "react";
import {postUnblockUser} from "../api";
import {AdminAction} from "../types";
import {useToast} from "use-toast-mui";

export const useUnblockUser = () => {
    const toast = useToast();

    const unblockUser: AdminAction = useCallback(async (activationKey: string): Promise<void> => {
        try {
            await postUnblockUser(activationKey);
        } catch (error) {
            toast.error("Something went wrong when unblocking a user.");
        }
    }, [toast])

    return {unblockUser}
}
